<template>
  <div class="scrollable">
    <v-header></v-header>
    <div class="content">
      <div class="nav" id="w1200">
        <p>体检服务 > 投诉建议</p>
      </div>
      <div class="scrollableBox">
        <div class="divText">请选择反馈类型：</div>
        <div class="scrollableBoxXuan">
          <el-radio v-model="radio" label="0">体检服务</el-radio>
          <el-radio v-model="radio" label="1">平台使用</el-radio>
        </div>
        <div class="divText">请填写反馈信息：</div>
        <div style="margin: 20px 0;"></div>
        <div class="divTextarea">
            <textarea
              type="textarea"
              placeholder="您的反馈将帮助我们更快成长"
              v-model="textarea"
              maxlength="200"
              show-word-limit
            ></textarea>
          <p class="pTextarea" style="text-align: right;margin-right: 40px;margin-top: -30px;">( 限100字)</p>
        </div>
        <div class="divText" style="margin-top:40px">请填写联系方式<span style="color: #FF000F;">(联系方式仅工作人员可见)：</span> </div>
        <div style="margin: 20px 0;"></div>
        <div class="divTextarea1">
            <textarea
              type="textarea"
              placeholder="手机号、QQ号或邮箱地址"
              v-model="concat"
              maxlength="200"
              show-word-limit
              style="height: 76px;"
            ></textarea>
        </div>
      </div>
      <div class="divBtn">
        <div :class="className == 'divButton'? 'divButton' : 'cssButton'" @click="onButtom">确认并提交</div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
    import axios from "axios";
    // import headerChild from "../components/headerChild";
    // import footerChild from "../components/footerChild";
    import header from "../common/header.vue";
    import footer from "../common/footer.vue";
    import {
        examFeedback
    } from "../../utils/api.js";

    export default {
        name: "",
        components: {
            "v-header": header,
            "v-footer": footer
        },

        data() {
            return {
                radio: '0',
                textarea: '',
                // className: 'divButton',
                concat: '',
            };
        },
        computed: {
            className() {
                return (this.textarea && this.concat) ? 'cssButton' : 'divButton'
            }

        },
        methods: {
            async onButtom() {
                if (this.className == 'divButton') {
                    return;
                }
                // let fd = new FormData();
                // fd.append("content", this.textarea);
                // fd.append("type", this.radio);
                // let config = {
                //     headers: {
                //       "access-token": localStorage.getItem("TOKEN")
                //     }
                // }
                let param = {
                    content: this.textarea,
                    type: this.radio,
                    contact: this.concat

                }
                await examFeedback(param).then((res) => {
                        if (res.data.data == 'OK') {
                            this.$message({
                                message: res.data.return_msg,
                                type: "success",
                                center: true,
                            });
                            this.$router.push({
                                path: "/phyExServices",
                            });
                        }
                    })
                    // let url = BASE_URL + '/exam/feedback/';
                    // axios.post(url, {
                    //     content: this.textarea,
                    //     type: this.radio,
                    //     headers: {
                    //       "access-token": localStorage.getItem("TOKEN")
                    //     }
                    //   }).then((res) => {
                    //     if (res.data.data == 'OK') {
                    //       this.$message({
                    //         message: res.data.return_msg,
                    //         type: "success",
                    //         center: true,
                    //       });
                    //       this.$router.push({
                    //         path: "/phyExServices",
                    //       });
                    //     }
                    //   })
            }
        }
    };
</script>

<style scoped lang="scss">
    $primary-color: #FF000F;
    #wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .content {
        width: 100%;
        padding-bottom: 100px;
        /* background: url("../assets/index-bg3.png") bottom no-repeat; */
    }
    
    .chart {
        width: 1000px;
        height: 740px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 17px 0px rgba(197, 197, 197, 0.35);
        position: relative;
        margin: 0 auto;
        &-topBoreder {
            width: 100%;
            height: 6px;
            background: rgba(255, 102, 51, 1);
            border-radius: 5px;
            position: absolute;
            top: -6px;
        }
        &-header {
            width: 100%;
            height: 84px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            position: relative;
            li {
                position: absolute;
                right: 17px;
                display: flex;
                align-items: center;
                i {
                    margin-right: 10px;
                }
                span {
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    text-decoration: underline;
                }
            }
        }
        &-container {
            width: 940px;
            height: 500px;
            background: rgba(242, 242, 242, 1);
            border-radius: 5px;
            margin: 0 auto;
            margin-bottom: 16px;
            overflow: auto;
        }
        &-footer {
            width: 940px;
            height: 100px;
            background: rgba(242, 242, 242, 1);
            border-radius: 5px;
            margin: 0 auto;
            display: flex;
            &-left {
                flex: 8;
                textarea {
                    width: 100%;
                    height: 100%;
                    border: none;
                    padding-top: 10px;
                    padding-left: 20px;
                    background: rgba(242, 242, 242, 1);
                }
                textarea::-webkit-input-placeholder {
                    color: #9e9e9e;
                }
            }
            &-right {
                flex: 2;
                position: relative;
                button {
                    position: absolute;
                    right: 10px;
                    top: 34px;
                    width: 80px;
                    height: 46px;
                    background: rgba(255, 102, 51, 1);
                    border-radius: 23px;
                    line-height: 26px;
                    text-align: center;
                    font-size: 20px !important;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 1);
                }
            }
        }
    }
    
    .scrollableBox {
        width: 1200px;
        height: 700px;
        margin: 0 auto;
        box-shadow: 0px 0px 30px 0px #EDF6FF;
        border-radius: 20px;
        background: #FFFFFF;
        padding: 30px;
        .divText {
            font-size: 18px;
            color: #333333;
            font-weight: 600;
            border-left: 4px solid #FF000F;
            padding-left: 17px;
        }
        .scrollableBoxXuan {
            height: 78px;
            line-height: 78px;
            margin-left: 17px;
        }
        textarea {
            height: 300px;
            width: 1120px;
            border: 1px solid #CCCCCC;
            padding: 30px;
            font-size: 18px;
        }
        .divTextarea1 {
            height: 76px;
            width: 1120px;
            position: relative;
            .pTextarea {
                text-align: right;
                /* position: absolute;
      width: 115px;
      color: #999999;
      font-size: 16px;
      bottom: 30px;
      right: 30px; */
            }
        }
    }
    
    .divBtn {
        width: 1200px;
        height: 50px;
        margin: 30px auto 0;
        .divButton,
        .cssButton {
            float: right;
            width: 180px;
            height: 46px;
            background: #999999;
            border-radius: 23px;
            line-height: 46px;
            text-align: center;
            font-weight: 600;
            color: #FFFFFF;
            font-size: 20px;
            cursor: pointer;
        }
        .cssButton {
            color: #FFFFFF;
            background: #FF000F;
        }
    }
    
    .nav {
        width: 1180px;
        margin: 0 auto;
        padding: 20px 0;
        font-size: 22px;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/suggestions1.vue